import { render, staticRenderFns } from "./DespesaTable.vue?vue&type=template&id=43675fc8"
import script from "./DespesaTable.vue?vue&type=script&lang=js"
export * from "./DespesaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports